import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import "react-image-gallery/styles/css/image-gallery.css";
import "./index.css";
import { useSelector, useDispatch } from "react-redux";
import { getApi, patchOrder } from "../../../../actions/structure.action";
import isEmpty from "../../../../utils/is-Empty";
import { Link, useNavigate } from "react-router-dom";
import Spinner from "../../../common/Spinner";
import TimestampConverter from "../../../../utils/TimestampConverter";
import OrderSummaryCard from "../../../Cart/OrderSummaryCard";
import { appConstants, stringConstants } from "../../../../helpers";
import axios from "axios";
import { BHAREE_BASE_URL_LOCAL } from "../../../../config/config.url";
import LogisticAssignSection from "./LogisticAssignSection";
import StatusBadge from "../../../Account/StatusBadge";
import { toast } from "react-toastify";
import { useDialog } from "../../../../helpers/useDialog";
import PageSpinner from "../../../common/PageSpinner";
import Razorpay from "../../../CheckOut/Razorpay";

const loadRazorpay = () => {
  return new Promise((resolve) => {
    // ✅ If already loaded, just resolve
    if (document.querySelector("#razorpay-script")) {
      return resolve(true);
    }

    const script = document.createElement("script");
    script.id = "razorpay-script";
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

const removeRazorpay = () => {
  const script = document.querySelector("#razorpay-script");
  if (script) {
    script.remove();
  }
};

const DashbordOrder = ({ id, closeModal, isModalOpen, dispatchObj, getLPDetails = null }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { alert, confirm, DialogModal } = useDialog();
  const [availableVehicles, setAvailableVehicles] = useState([]);
  const [reassignLP, setReassignLP] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingQR, setLoadingQR] = useState(false);
  const [podQR, setPodQR] = useState(null);
const [showPodQR, setShowPodQR] = useState(false);
  const { currentOrder, auth, vehicleLoadStatistics } = useSelector((state) => {
    return state;
  });

  const [vehicleAcceptedLoad, setVehicleAcceptedLoad] = useState(0);
  const [vehicleAcceptedLoadPercentage, setVehicleAcceptedLoadPercentage] = useState(0);

  useEffect(() => {
    if (
      !isEmpty(vehicleLoadStatistics?.data) &&
      !isEmpty(currentOrder?.data) &&
      auth?.user?.role?.role_name === stringConstants.ROLL_LOGISTIC_PARTNER
    ) {
      let vehicleData = vehicleLoadStatistics?.data.find(
        (vehicle) =>
          vehicle?.vehicleInfo?.vehicle_reg_no ===
          currentOrder?.data?.logisticPartnerVehicle?.vehicle_reg_no,
      );
      console.log("----> vehicleData: ", vehicleData);
      if (!vehicleData) {
        vehicleData = vehicleLoadStatistics?.data.find(
          (vehicle) =>
            vehicle?.vehicleInfo?.vehicle_reg_no ===
            currentOrder?.data?.logisticPartner?.vehicle_reg_no,
        );
      }
      if (vehicleData) {
        setVehicleAcceptedLoad(vehicleData?.lpAcceptedLoad + vehicleData.outForDeliveryLoad);
      }

      const maxPayLoad =
        currentOrder?.data?.logisticPartnerVehicle?.vehicle_payload_capacity ||
        currentOrder?.data?.logisticPartner?.vehicle_payload_capacity;
      if (maxPayLoad && vehicleData) {
        setVehicleAcceptedLoadPercentage(
          ((vehicleData?.lpAcceptedLoad + vehicleData.outForDeliveryLoad) / maxPayLoad) * 100,
        );
      } else {
        setVehicleAcceptedLoadPercentage(0);
      }
    }
  }, [vehicleLoadStatistics, currentOrder, auth]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    getApi("getOrder", dispatch, "/" + id);
  }, [id]);

  useEffect(() => {
    if (!isEmpty(currentOrder?.data?.seller_id?.seller_id)) {
      getAvailableLP(currentOrder?.data?.seller_id?.seller_id);
    }
  }, [currentOrder]);

  const getAvailableLP = async (sellerId) => {
    try {
      const response = await axios.get(
        BHAREE_BASE_URL_LOCAL + "/logistics/getAllAvailable/" + sellerId,
        {
          headers: {
            Authorization: `Bearer ${localStorage.jwtToken}`,
          },
        },
      );

      if (response && response?.data) {
        if (response?.data?.success) {
          setAvailableVehicles(response?.data?.data);
        }
      }

      return response;
    } catch (error) {
      console.error("getAvailableLP error:", error.response || error.message);
      throw error;
    } finally {
    }
  };

  const handleDownloadInvoice = () => {
    navigate(`/invoice/${currentOrder?.data?.id}`);
  };

  const acceptOrderStatus = (orderId) => {
    let sendObj = {};
    sendObj["id"] = orderId;
    sendObj["status"] = "accepted";
    patchOrder(sendObj, dispatch, dispatchObj);
  };

  const assignToLP = async (orderId, selectedVehicle, totalPriceObj) => {
    try {
      console.log("Selected Vehicle: ", orderId, selectedVehicle);

      const sendObj = {
        id: orderId,
        status: "shipped",
        logisticPartnerId: selectedVehicle.value,
        logisticVehicleId: selectedVehicle.data?.logistic_vehicle_id,
        totalKmPrice: {
          per_km_rate: selectedVehicle.data?.business_info?.per_km_rate,
          total_km_value: totalPriceObj?.totalPrice || null,
          total_km: totalPriceObj?.km || null,
        },
      };

      setLoading(true);
      const response = await patchOrder(sendObj, dispatch, dispatchObj);
      setLoading(false);
      console.log("Assign to LP: ", response);
      console.log("IsModalOpen: ", isModalOpen);
      if (response.success) {
        if (isModalOpen) {
          closeModal();
        }
      }
    } catch (err) {
      console.error("Error assigning logistic partner:", err);
      toast.error("Failed to assign logistic partner.");
    }
  };

  const markLPAccepted = async (orderId) => {
    console.log("Selected Order: ", orderId);
    try {
      const sendObj = {
        id: orderId,
        status: "lpaccepted",
      };

      const response = await patchOrder(sendObj, dispatch, dispatchObj);
      console.log("Mark LP Accepted: ", response);
      if (response.success) {
        if (isModalOpen) {
          closeModal();
        }
      }

      getApi("getVehicleLoadStatistics", dispatch, auth?.user?.id);
    } catch (err) {
      console.error("Failed to mark LP accepted:", err);
      toast.error("Failed to mark LP accepted.");
    }
  };

  const markOutForDelivery = async (orderId) => {
    console.log("Selected Order: ", orderId);
    try {
      const sendObj = {
        id: orderId,
        status: "outfordelivery",
      };

      const response = await patchOrder(sendObj, dispatch, dispatchObj);
      console.log("Mark Out for Delivery: ", response);
      if (response.success) {
        if (isModalOpen) {
          closeModal();
        }
      }

      getApi("getVehicleLoadStatistics", dispatch, auth?.user?.id);
    } catch (err) {
      console.error("Failed to mark out for delivery:", err);
      toast.error("Failed to mark out for delivery.");
    }
  };

  const markDelivered = async (orderId) => {
    console.log("Selected Order: ", orderId);
    try {
      const sendObj = {
        id: orderId,
        status: "delivered",
      };

      const response = await patchOrder(sendObj, dispatch, dispatchObj);
      console.log("Mark Delivered: ", response);
      if (response.success) {
        if (isModalOpen) {
          closeModal();
        }
        if (getLPDetails) {
          getLPDetails();
        }
      }

      getApi("getVehicleLoadStatistics", dispatch, auth?.user?.id);
    } catch (err) {
      console.error("Failed to mark delivered:", err);
      toast.error("Failed to mark delivered.");
    }
  };

  const SummaryBox = () => {
    if (!isEmpty(currentOrder.data)) {
      return (
        <>
          <div
            style={{
              display:
                auth?.user?.role?.role_name === stringConstants.ROLL_LOGISTIC_PARTNER
                  ? "none"
                  : "block",
            }}
          >
            <p className="m-0">{"Order Summary"}</p>
            <Row className="price-box mx-0 my-2">
              <Col xs={2} md={3}></Col>
              <Col xs={6} md={6} className="title p-0">
                {"Subtotal:"}
              </Col>
              <Col xs={4} md={3} className="amount p-0">
                {/* {parseFloat(checkoutItems?.data.totalAmount).toFixed(2) || 0}&nbsp;{"₹"} */}
                {currentOrder?.data?.totalAmount} &nbsp;{"₹"}
              </Col>
            </Row>
            <Row className="price-box mx-0 my-2">
              <Col xs={2} md={3}></Col>
              <Col xs={6} md={6} className="title p-0">
                {"Delivery Charges:"}
              </Col>
              <Col xs={4} md={3} className="amount p-0">
                {currentOrder?.data?.totalDelivery} &nbsp;{"₹"}
              </Col>
            </Row>
            <Row className="price-box mx-0 my-2">
              <Col xs={2} md={3}></Col>
              <Col xs={6} md={6} className="title p-0">
                {"Handling Charges:"}
              </Col>
              <Col xs={4} md={3} className="amount p-0">
                {currentOrder?.data?.totalHandlingCharges || "0.00"} &nbsp;{"₹"}
              </Col>
            </Row>
            <Row className="price-box mx-0 my-2">
              <Col xs={2} md={3}></Col>
              <Col xs={10} md={9} className="title p-0">
                <hr className="mx-0 cutomeHR" />
              </Col>
            </Row>
            <Row className="price-box mx-0 my-2">
              <Col xs={2} md={3}></Col>
              <Col xs={6} md={6} className="amount p-0">
                {"Payable Amount"}
              </Col>
              <Col xs={4} md={3} className="amount p-0">
                {currentOrder?.data?.payableAmount} &nbsp;{"₹"}
              </Col>
            </Row>
          </div>
        </>
      );
    }
  };

  const handleGeneratePaymentLink = (orderData) => {
    console.log("Order Data: ", orderData);
    if (!isEmpty(orderData?.id)) {
      setLoading(true);
      axios
        .get(`${BHAREE_BASE_URL_LOCAL}/orders/get-payment-link/${orderData?.id}`, {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${localStorage.jwtToken}`,
          },
        })
        .then(async (response) => {
          setLoading(false);
          if (response?.data?.data?.short_url) {
            await alert(
              <>
                Payment link generated successfully. The generated link has been sent to the
                customer's registered contact email. <br />
                <strong className="text-info">
                  Please ask the customer to complete the payment using the provided link.
                </strong>
                <br />
                <strong className="text-danger">
                  After customer confirms the payment, please click on 'Delivered' button to check
                  the payment status and mark the order as delivered.
                </strong>
              </>,
            );
            if (isModalOpen) {
              closeModal();
            }
          } else {
            await alert("Failed to get payment link.");
          }
        })
        .catch(async (err) => {
          setLoading(false);
          console.error("Error fetching payment link:", err);
          await alert("Error fetching payment link.");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };
  const handleGeneratePodQR = async (orderData) => {
  if (!orderData?.id) {
    toast.error("Order ID not found");
    return;
  }

  try {
    setLoadingQR(true);

    const response = await axios.post(
      `${BHAREE_BASE_URL_LOCAL}/orders/generate-pod-qr/${orderData.id}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.jwtToken}`,
        },
      }
    );

    if (response.data.success) {
      setPodQR(response.data.data);
      setShowPodQR(true);

      toast.success("Payment QR generated successfully");
    } else {
      toast.error(
        response.data.message || "QR generation failed"
      );
    }
  } catch (error) {
    console.error("QR Generation Error:", error);

    toast.error(
      error.response?.data?.message ||
      "Failed to generate payment QR"
    );
  } finally {
    setLoadingQR(false);
  }
};

  const handleGenerateQRCode = async (orderData) => {
    if (!isEmpty(orderData?.id)) {
      const loaded = await loadRazorpay();
      if (!loaded) {
        await alert("Razorpay SDK failed to load. Check your internet connection.");
        return;
      }

      setLoadingQR(true);

      const response = await axios.get(
        `${BHAREE_BASE_URL_LOCAL}/orders/create-order-payment/${orderData?.id}`,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${localStorage.jwtToken}`,
          },
        },
      );

      // console.log("ORDER RESPONSE: ", response);
      if (response) {
        if (response?.data?.success) {
          const responseData = response?.data?.data;
          const options = {
            key: process.env.REACT_APP_RZRPAY_KEY_ID, // Enter the Key ID generated from the Dashboard
            amount: responseData.amount,
            currency: "INR",
            name: "Bharee Order Payment",
            description: "Payment for your order",
            order_id: responseData.razorpayOrderId,
            handler: function (response) {
              setLoadingQR(true);
              axios
                .post(BHAREE_BASE_URL_LOCAL + "/api/podPaymentCallback/" + orderData.id, response, {
                  headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    Authorization: `Bearer ${localStorage.jwtToken} `,
                  },
                })
                .then(async (res) => {
                  console.log("Payment verification response:", res);
                  if (res.data.success) {
                    await alert("Payment successful!");
                    // Refresh order details to reflect payment status
                    getApi("getOrder", dispatch, "/" + id);
                    getApi("getOrders", dispatch);
                  } else {
                    await alert("Payment verification failed!");
                  }
                })
                .catch(async (err) => {
                  console.error("Payment verification error:", err);
                  await alert("Payment verification error!");
                })
                .finally(() => {
                  setLoadingQR(false);
                });

              // ✅ Clean up after success
              removeRazorpay();
            },
            config: {
              display: {
                hide: [
                  { method: "paylater" },
                  { method: "emi" },
                  { method: "wallet" },
                  { method: "card" },
                  { method: "netbanking" },
                ],
                preferences: { show_default_blocks: true },
                widget: {
                  main: {
                    isDarkMode: true, //default is false
                  },
                },
              },
            },
            prefill: {
              name: responseData.prefill.name,
              email: responseData.prefill.email,
              contact: responseData.prefill.contact,
            },
            notes: {
              address: "Bharee Customer Address",
            },
            theme: {
              color: "#fbb040",
            },
            modal: {
              confirm_close: true, // this is set to true, if we want confirmation when clicked on cross button.
              ondismiss: async (reason) => {
                console.log("Checkout closed by user");
                const {
                  reason: paymentReason,
                  field,
                  step,
                  code,
                } = reason && reason.error ? reason.error : {};

                console.log("paymentReason: ", paymentReason);
                console.log("field: ", field);
                console.log("step: ", step);
                console.log("code: ", code);

                // Reason 1 - when payment is cancelled. It can happen when we click cross icon or cancel any payment explicitly.
                if (reason === undefined) {
                  console.log("cancelled");
                }
                // Reason 2 - When modal is auto closed because of time out
                else if (reason === "timeout") {
                  console.log("timeout");
                }
                // Reason 3 - When payment gets failed.
                else {
                  console.log("failure");
                }

                // ✅ Clean up if user closes checkout
                removeRazorpay();
              },
            },
            // This property allows to enble/disable retries.
            // This is enabled true by default.
            retry: {
              enabled: false,
            },
          };

          const rzp = new window.Razorpay(options);
          rzp.open();
        } else {
          await alert(response?.data?.message);
        }
      }

      setLoadingQR(false);
    }
  };

  return (
    <>
      <section className="order-main-section">
        {DialogModal}
        {loading && <PageSpinner />}
        {loadingQR && <PageSpinner />}
        {(() => {
          if (!currentOrder.loading && !isEmpty(currentOrder?.data)) {
            return (
              <div className="py-4">
                <div className="order-section-title-div">
                  <h4 className="order-section-title m-0">{"Order Details"}</h4>
                </div>
                <div id="borderLeft"></div>

                <Row className="m-0 py-2 order-info">
                  <Col xs={12} sm={12} md={8} lg={8} className="p-0 text-start">
                    <div>
                      <p className="m-0">
                        Order ID: <span># {currentOrder?.data?.orderId}</span>
                        {" | "}
                        Status: <StatusBadge status={currentOrder?.data?.status} />{" "}
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={4} lg={4} className="p-0  left-col">
                    <div>
                      <p className="m-0">
                        Order Placement Date:{" "}
                        <span>{TimestampConverter(currentOrder?.data?.order_date)}</span>{" "}
                      </p>
                    </div>
                  </Col>
                </Row>
                <Row className="m-0 py-2">
                  <Col xs={12} sm={12} md={8} lg={8} className="p-0">
                    {/* <OrderSummaryCard card={currentOrder?.data?.product_variant_id[0]} crud={false} /> */}
                    {/* {!isEmpty(cardItem) && } */}
                    <OrderSummaryCard
                      card={currentOrder?.data}
                      crud={false}
                      currentOrderView={true}
                    />
                  </Col>
                  <Col xs={12} sm={12} md={4} lg={4} className="order-summery-price p-0">
                    {SummaryBox()}
                  </Col>
                  <Col xs={12} sm={12} md={8} lg={8} className="p-0 text-start">
                    <div>
                      {auth?.user?.role?.role_name !== stringConstants.LOGISTIC_PARTNER && (
                        <p className="m-0">
                          <strong>{"Expected Delivery Date:"}</strong>{" "}
                          <span>
                            {" "}
                            {TimestampConverter(currentOrder?.data?.expected_delivery_date, true)}
                          </span>{" "}
                        </p>
                      )}
                      {!isEmpty(currentOrder?.data?.accepted_at) &&
                        auth?.user?.role?.role_name !== stringConstants.LOGISTIC_PARTNER && (
                          <p className="m-0">
                            <strong>{"Confirmed Date:"}</strong>{" "}
                            <span>
                              {" "}
                              {TimestampConverter(currentOrder?.data?.accepted_at, true)}
                            </span>{" "}
                          </p>
                        )}
                      {!isEmpty(currentOrder?.data?.shipped_at) && (
                        <p className="m-0">
                          <strong>{"Assigned to LP Date:"}</strong>{" "}
                          <span>
                            {" "}
                            {TimestampConverter(currentOrder?.data?.shipped_at, true)}
                          </span>{" "}
                        </p>
                      )}
                      {!isEmpty(currentOrder?.data?.lp_accepted_at) && (
                        <p className="m-0">
                          <strong>{"LP Accepted Date:"}</strong>{" "}
                          <span>
                            {" "}
                            {TimestampConverter(currentOrder?.data?.lp_accepted_at, true)}
                          </span>{" "}
                        </p>
                      )}
                      {!isEmpty(currentOrder?.data?.outfordelivery_at) && (
                        <p className="m-0">
                          <strong>{"Out for Delivery Date:"}</strong>{" "}
                          <span>
                            {" "}
                            {TimestampConverter(currentOrder?.data?.outfordelivery_at, true)}
                          </span>{" "}
                        </p>
                      )}
                      {!isEmpty(currentOrder?.data?.delivered_at) && (
                        <p className="m-0">
                          <strong>{"Delivered Date:"}</strong>{" "}
                          <span>
                            {" "}
                            {TimestampConverter(currentOrder?.data?.delivered_at, true)}
                          </span>{" "}
                        </p>
                      )}
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={4} lg={4} className="order-summery-price p-0">
                    <div className="mt-0">
                      <p className="m-0">
                        <strong>Payment Status:</strong>{" "}
                        {(() => {
                          if (currentOrder?.data?.payment_status_id === "success") {
                            return (
                              <span class="text-uppercase text-success">
                                {currentOrder?.data?.payment_status_id}
                              </span>
                            );
                          } else if (currentOrder?.data?.payment_status_id === "pending") {
                            return (
                              <span class="text-uppercase text-warning">
                                {currentOrder?.data?.payment_status_id}
                              </span>
                            );
                          } else {
                            return (
                              <span class="text-uppercase text-danger">
                                {currentOrder?.data?.payment_status_id}
                              </span>
                            );
                          }
                        })()}
                      </p>
                      {(() => {
                        if (
                          currentOrder?.data?.payment_status_id !== "success" &&
                          currentOrder?.data?.status === "outfordelivery"
                        ) {
                          return (
                            <div className="mt-2">
                              <Button
                                className="btn btn-primary"
                                disabled={loading}
                                onClick={() => {
                                  handleGeneratePaymentLink(currentOrder?.data);
                                }}
                              >
                                {loading ? (
                                  <>
                                    <span
                                      className="spinner-border spinner-border-sm me-2"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    Generating...
                                  </>
                                ) : (
                                  <>
                                    <i className="bi bi-currency-rupee"></i> Generate Payment Link
                                  </>
                                )}
                              </Button>
                              <Button
  className="btn btn-success ms-2"
  disabled={loadingQR}
  onClick={() => {
    handleGeneratePodQR(currentOrder?.data);
  }}
>
  {loadingQR ? (
    <>
      <span className="spinner-border spinner-border-sm me-2" />
      Generating QR...
    </>
  ) : (
    <>
      <i className="bi bi-qr-code me-2"></i>
      Generate Payment QR
    </>
  )}
</Button>
{showPodQR && podQR?.qrImage && (
  <div className="text-center mt-3 p-3 border rounded">
    <h5>Scan & Pay</h5>

    {podQR.amount != null && (
      <h3>₹{Number(podQR.amount).toFixed(2)}</h3>
    )}

    <img
      src={podQR.qrImage}
      alt="Bharee UPI Payment QR"
      style={{
        width: "230px",
        height: "230px",
        objectFit: "contain",
      }}
    />

    <p className="mt-3">
      Scan using Google Pay, PhonePe, Paytm
      or any supported UPI app.
    </p>

    <p className="text-warning">
      Awaiting Payment Confirmation
    </p>

    <Button
      variant="outline-secondary"
      onClick={() => {
        setShowPodQR(false);
      }}
    >
      Close QR
    </Button>
  </div>
)}

                              {/* <Button
                                className="btn btn-primary ms-2"
                                disabled={loadingQR}
                                onClick={() => {
                                  handleGenerateQRCode(currentOrder?.data);
                                }}
                              >
                                {loadingQR ? (
                                  <>
                                    <span
                                      className="spinner-border spinner-border-sm me-2"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    Generating...
                                  </>
                                ) : (
                                  <>
                                    <i className="bi bi-currency-rupee"></i> Generate QR Code
                                  </>
                                )}
                              </Button> */}
                            </div>
                          );
                        }
                      })()}
                    </div>
                    {currentOrder?.data?.invoice_status === true &&
                      auth?.user?.role?.role_name !== stringConstants.ROLL_LOGISTIC_PARTNER && (
                        <div className="mt-2">
                          <Button className="btn btn-primary" onClick={handleDownloadInvoice}>
                            <i className="bi bi-receipt"></i> Invoice
                          </Button>
                        </div>
                      )}
                  </Col>
                </Row>

                <Row className="m-0 py-2 order-info">
                  <Col xs={12} sm={12} md={4} lg={4} className="p-0 text-start">
                    <div className="order-section-title-div">
                      <h4 className="order-section-title m-0">{"Delivery Address"}</h4>
                    </div>
                    <div id="borderLeft"></div>
                    <div>
                      <p className="m-0">
                        <span>{currentOrder?.data?.buyerInfo?.business_name}</span>
                      </p>
                    </div>
                    {auth?.user?.role?.role_name === stringConstants.ROLL_BHAREE && (
                      <>
                        <div>
                          <p className="m-0">
                            Contact Number :{" "}
                            <span>{currentOrder?.data?.delivery_address_id?.primary_number}</span>
                          </p>
                        </div>
                      </>
                    )}
                    <div>
                      <p className="m-0">
                        {" "}
                        <span>
                          {" "}
                          {currentOrder?.data?.delivery_address_id?.address_line_1}{" "}
                          {currentOrder?.data?.delivery_address_id?.address_line_2}{" "}
                          {currentOrder?.data?.delivery_address_id?.address_line_3}{" "}
                        </span>
                      </p>
                    </div>
                    <div>
                      <p className="m-0">
                        City:<span> {currentOrder?.data?.delivery_address_id?.city}</span>
                      </p>
                    </div>
                    <div>
                      <p className="m-0">
                        State:<span> {currentOrder?.data?.delivery_address_id?.state} </span>
                      </p>
                    </div>
                    <div>
                      <p className="m-0">
                        Country:<span> {currentOrder?.data?.delivery_address_id?.country} </span>
                      </p>
                    </div>
                    <div>
                      <p className="m-0">
                        Pin code: <span>{currentOrder?.data?.delivery_address_id?.pin_code}</span>
                      </p>
                    </div>
                  </Col>
                  {auth?.user?.role?.role_name === stringConstants.ROLL_BHAREE ? (
                    <Col xs={12} sm={12} md={4} lg={4} className="p-0 text-start">
                      <div className="order-section-title-div">
                        <h4 className="order-section-title m-0">{"Pick Up Address"}</h4>
                      </div>
                      <div id="borderLeft"></div>
                      <div>
                        <p className="m-0">
                          Seller : <span>{currentOrder?.data?.seller_address_id?.full_name}</span>
                        </p>
                      </div>
                      <div>
                        <p className="m-0">
                          Seller contact Number :{" "}
                          <span>{currentOrder?.data?.seller_address_id?.primary_number}</span>
                        </p>
                      </div>
                      <div>
                        <p className="m-0">
                          {" "}
                          <span>
                            {" "}
                            {currentOrder?.data?.seller_address_id?.address_line_1}{" "}
                            {currentOrder?.data?.seller_address_id?.address_line_2}{" "}
                            {currentOrder?.data?.seller_address_id?.address_line_3}{" "}
                          </span>
                        </p>
                      </div>
                      <div>
                        <p className="m-0">
                          City:<span> {currentOrder?.data?.seller_address_id?.city}</span>
                        </p>
                      </div>
                      <div>
                        <p className="m-0">
                          State:<span> {currentOrder?.data?.seller_address_id?.state} </span>
                        </p>
                      </div>
                      <div>
                        <p className="m-0">
                          Country:<span> {currentOrder?.data?.seller_address_id?.country} </span>
                        </p>
                      </div>

                      <div>
                        <p className="m-0">
                          Pin code: <span>{currentOrder?.data?.seller_address_id?.pin_code}</span>
                        </p>
                      </div>
                    </Col>
                  ) : (
                    <Col xs={12} sm={12} md={4} lg={4} className="p-0 text-start"></Col>
                  )}
                  {!isEmpty(currentOrder?.data) &&
                    (currentOrder?.data?.status === "placed" ||
                      currentOrder?.data?.status === "inprocess") && (
                      <Col
                        xs={12}
                        sm={12}
                        md={4}
                        lg={4}
                        className="p-0 d-flex flex-column justify-content-end left-col"
                      >
                        <Button
                          variant="primary"
                          className="accept action-button"
                          onClick={() => {
                            acceptOrderStatus(currentOrder?.data?.id);
                          }}
                        >
                          <i class="bi bi-check"></i> Accept Order
                        </Button>
                      </Col>
                    )}

                  {!isEmpty(currentOrder?.data) &&
                    (currentOrder?.data?.status === "shipped" ||
                      currentOrder?.data?.status === "lpaccepted" ||
                      currentOrder?.data?.status === "outfordelivery" ||
                      currentOrder?.data?.status === "delivered") && (
                      <Col xs={12} sm={12} md={4} lg={4} className="p-0 text-start">
                        <div className="order-section-title-div">
                          <h4 className="order-section-title m-0">{"Logistic Partner Details:"}</h4>
                        </div>
                        <div id="borderLeft"></div>
                        <div>
                          <p className="m-0">
                            Name:{" "}
                            <span>
                              {currentOrder?.data?.logisticPartnerVehicle?.driver_name ||
                                currentOrder?.data?.logisticPartner?.driver_name}
                            </span>
                          </p>
                          <p className="m-0">
                            Contact:{" "}
                            <span>
                              {currentOrder?.data?.logisticPartnerVehicle?.driver_contact ||
                                currentOrder?.data?.logisticPartner?.driver_contact}
                            </span>
                          </p>
                          <p className="m-0">
                            Email:{" "}
                            <span>
                              {currentOrder?.data?.logisticPartnerVehicle?.driver_email ||
                                currentOrder?.data?.logisticPartner?.driver_email}
                            </span>
                          </p>
                          <p className="m-0">
                            Reg No:{" "}
                            <span>
                              {currentOrder?.data?.logisticPartnerVehicle?.vehicle_reg_no ||
                                currentOrder?.data?.logisticPartner?.vehicle_reg_no}
                            </span>
                          </p>
                          <p className="m-0">
                            Max Payload:{" "}
                            <span>
                              {currentOrder?.data?.logisticPartnerVehicle
                                ?.vehicle_payload_capacity ||
                                currentOrder?.data?.logisticPartner?.vehicle_payload_capacity}{" "}
                              kg
                            </span>
                          </p>
                          {vehicleLoadStatistics &&
                            auth?.user?.role?.role_name === stringConstants.LOGISTIC_PARTNER && (
                              <p className="m-0">
                                Accepted Load:{" "}
                                <span>
                                  {vehicleAcceptedLoad} /{" "}
                                  {currentOrder?.data?.logisticPartnerVehicle
                                    ?.vehicle_payload_capacity ||
                                    currentOrder?.data?.logisticPartner
                                      ?.vehicle_payload_capacity}{" "}
                                  kg ({vehicleAcceptedLoadPercentage.toFixed(0)}%)
                                </span>
                              </p>
                            )}
                          {currentOrder?.data?.total_km && (
                            <p className="m-0">
                              Total KM: <span>{currentOrder?.data?.total_km} km</span>
                            </p>
                          )}
                          {currentOrder?.data?.per_km_rate && (
                            <p className="m-0">
                              Total KM Rate: <span>₹{currentOrder?.data?.per_km_rate}/km</span>
                            </p>
                          )}
                          {currentOrder?.data?.total_km_value && (
                            <p className="m-0">
                              Total KM Value: <span>₹{currentOrder?.data?.total_km_value}</span>
                            </p>
                          )}
                        </div>

                        {(auth?.user?.role?.role_name === stringConstants.ROLL_BHAREE ||
                          auth?.user?.role?.role_name === stringConstants.ROLL_SELLER) &&
                          currentOrder?.data?.status === "shipped" &&
                          !reassignLP && (
                            <div className="mt-2 w-100 text-end">
                              <Button variant="primary" onClick={() => setReassignLP(true)}>
                                <i class="bi bi-person-add"></i> Reassign LP
                              </Button>
                            </div>
                          )}

                        {auth?.user?.role?.role_name === stringConstants.ROLL_LOGISTIC_PARTNER &&
                          currentOrder?.data?.status === "shipped" && (
                            <div className="mt-2 w-100 text-end">
                              <Button
                                variant="primary"
                                onClick={async () => {
                                  if (vehicleAcceptedLoadPercentage >= 100) {
                                    const isLoadAcceptConfirm = await confirm(
                                      <div className="text-dark">
                                        <i className="bi bi-exclamation-triangle-fill text-warning me-2" />
                                        <strong>Warning:</strong> The vehicle load capacity limit is
                                        already reached or higher. Are you sure you want to proceed?
                                      </div>,
                                      <>
                                        <i className="bi bi-exclamation-triangle-fill text-warning me-2" />
                                        Confirmation Required!
                                      </>,
                                    );
                                    if (!isLoadAcceptConfirm) {
                                      return;
                                    }
                                  }
                                  markLPAccepted(currentOrder?.data?.id);
                                }}
                              >
                                <i class="bi bi-hand-thumbs-up-fill"></i> Accept Trip
                              </Button>
                            </div>
                          )}

                        {auth?.user?.role?.role_name === stringConstants.ROLL_LOGISTIC_PARTNER &&
                          (currentOrder?.data?.status === "lpaccepted" ||
                            currentOrder?.data?.status === "outfordelivery") && (
                            <div className="mt-2 w-100 text-end">
                              <Button
                                variant="primary"
                                onClick={() => {
                                  if (currentOrder?.data?.status === "lpaccepted") {
                                    markOutForDelivery(currentOrder?.data?.id);
                                  } else if (currentOrder?.data?.status === "outfordelivery") {
                                    if (currentOrder?.data?.payment_status_id !== "success") {
                                      alert(
                                        "Payment not completed. Cannot mark order as delivered. Please click on 'View' to check payment details and ask the customer to complete the payment. You can generate the payment link or show the QR code to the customer for completing the payment.",
                                      );
                                      return;
                                    }
                                    markDelivered(currentOrder?.data?.id);
                                  }
                                }}
                              >
                                {currentOrder?.data?.status === "lpaccepted" && (
                                  <>
                                    <i class="bi bi-truck"></i> Mark Out For Delivery
                                  </>
                                )}
                                {currentOrder?.data?.status === "outfordelivery" && (
                                  <>
                                    <i class="bi bi-truck-flatbed"></i> Mark Delivered
                                  </>
                                )}
                              </Button>
                            </div>
                          )}
                      </Col>
                    )}

                  {!isEmpty(currentOrder?.data) && currentOrder?.data?.status === "accepted" && (
                    <LogisticAssignSection
                      currentOrder={currentOrder}
                      availableVehicles={availableVehicles}
                      assignToLP={assignToLP}
                    />
                  )}
                </Row>

                {!isEmpty(currentOrder?.data) && reassignLP && (
                  <Row className="m-0 py-2 order-info">
                    <Col xs={12} sm={12} md={8} lg={8} className="p-0"></Col>
                    <LogisticAssignSection
                      currentOrder={currentOrder}
                      availableVehicles={availableVehicles}
                      assignToLP={assignToLP}
                      reassignLP={reassignLP}
                      setReassignLP={setReassignLP}
                    />
                  </Row>
                )}
              </div>
            );
          } else if (currentOrder.loading) {
            return <Spinner />;
          }
        })()}
      </section>
    </>
  );
};

export default DashbordOrder;
